import { refreshAccessToken } from '~/auth/tokenStore';
import { isAuthenticationFailure } from '~/data/liftApiMutator';

/**
 * `fetch` for a request that carries the session's bearer token without going
 * through the generated SDK, such as the Otto chat stream. As in the SDK
 * mutator, a refused credential gets one refresh and one retry, and a refused
 * refresh ends the session. The refusal arrives before any of the stream, so
 * the retry sends nothing twice.
 */
export const fetchWithSessionRefresh: typeof fetch = async (input, init) => {
  const response = await fetch(input, init);
  const headers = new Headers(init?.headers);
  const sentToken = headers.get('Authorization')?.replace(/^Bearer /, '');
  if (!sentToken || !(await isAuthenticationFailure(response))) {
    return response;
  }
  headers.set('Authorization', `Bearer ${await refreshAccessToken(sentToken)}`);
  return fetch(input, { ...init, headers });
};
